import { OrderDoc } from '@gooduncles/gu-app-schema';
import { Card, Tag } from 'antd';
import { format, parseISO } from 'date-fns';
import { FC } from 'react';

import { formatNumber } from 'src/utils/common';
import { getOrderStatusKr, getStatusBadgeStatus } from 'src/utils/order-util';

import OrderAndLogViewModal from 'src/atomic-components/organisms/OrderAndLogView/OrderAndLogViewModal';

import classes from './StoreSection.module.scss';

interface RecentOrderCardProps {
  order: OrderDoc;
  isSelected: boolean;
  onSelect: () => void;
}

const RecentOrderCard: FC<RecentOrderCardProps> = ({ order, isSelected, onSelect }) => {
  const formatOrderDate = (dateStr: string) => {
    try {
      return format(parseISO(dateStr), 'yy/MM/dd HH:mm');
    } catch {
      return dateStr;
    }
  };

  const badgeStatus = getStatusBadgeStatus(order.orderStatus);
  const tagColor = badgeStatus === 'default' ? undefined : badgeStatus;

  return (
    <Card
      size='small'
      className={`${classes.orderCard} ${isSelected ? classes.selected : ''}`}
      hoverable
      onClick={onSelect}
    >
      <div className={classes.orderCardContent}>
        <span className={classes.orderDate}>{formatOrderDate(order.orderDate)}</span>
        <Tag color={tagColor}>{getOrderStatusKr(order.orderStatus)}</Tag>
        <span className={classes.orderAmount}>{formatNumber(order.grandTotal ?? order.paidAmount)}원</span>
        <OrderAndLogViewModal orderId={order._id} smallButton />
      </div>
    </Card>
  );
};

export default RecentOrderCard;
